import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/5_2.mp3"
export default function P1() {
    return (
        <MainLayout
        title="A załatwisz mi pan pracę w miasteczku?"     
        question="" 
            audio={audio}
        answers={{
            ans1: "Kto to jest ten Łukaszewski?",
            ans2: "A daleko do tego Tarszewa?",    
        }}
        links={{
            link1: PAGES.p12,
            link2: PAGES.p13,
        }}
        content={
            <div>
                <ul>
                    <li>A załatwi mi pan pracę w miasteczku?</li>
                    <li>Pracy to tyle, ile tych śliwek. Na garnitur zbieram, a Lejmer, mój sąsiad znaczy, obiecał mi dać materiału za te śliwki. Ach, ile jeszcze tego… Nie wiem, co on zrobi z tyloma śliwkami, ale i dla nas trochę zostanie. Za tę fatygę zapraszam cię na kolację do Łukaszewskiego! A i nocleg dam!</li>
                    <li>A gdzie pan mieszka?</li>
                    <li>Tam w łąkach, w Tarszewie.</li>
                </ul>
            </div>
        }
        />
        
            );
}